import { render, staticRenderFns } from "./loanMarket.vue?vue&type=template&id=25f435e5&scoped=true&"
import script from "./loanMarket.vue?vue&type=script&lang=js&"
export * from "./loanMarket.vue?vue&type=script&lang=js&"
import style0 from "./loanMarket.vue?vue&type=style&index=0&id=25f435e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f435e5",
  null
  
)

export default component.exports